import React from 'react';
import './style.scss';

function Footer() {
  return (
    <div>
      <div className="footer">
        <ul className="links">
          <li>About</li>
          <li>Help</li>
          <li>Press</li>
          <li>API</li>
          <li>Jobs</li>
          <li>Privacy</li>
          <li>Terms</li>
          <li>Locations</li>
          <li>Top Accounts</li>
          <li>Hashtags</li>
          <li>Language</li>
        </ul>
        <div className="copyright">@ 2021 PHOTOGRAM FROM KELVIN</div>
      </div>
    </div>
  );
}

export default Footer;
